//@ts-nocheck
import { routingMixin } from "@jack-henry/web-component-router";
import { LitElement, css, html, PropertyValues } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import "@banno/jha-wc/src/buttons/jha-button/jha-button";
import "@banno/jha-wc/src/forms/jha-form-select/jha-form-select";
import "@banno/jha-wc/src/cards/jha-card/jha-card";
import "@banno/jha-wc/src/icons/jha-icon-view-more";
import "@banno/jha-wc/src/icons/jha-icon-plus";
import "@banno/jha-wc/src/dropdowns/jha-dropdown-toggle/jha-dropdown-toggle";
import "@banno/jha-wc/src/dropdowns/jha-dropdown-menu/jha-dropdown-menu";
import "@banno/jha-wc/src/dropdowns/jha-dropdown-menu-item/jha-dropdown-menu-item";
import "@banno/jha-wc/src/dropdowns/jha-dropdown/jha-dropdown";
import "@banno/jha-wc/src/tables/advanced/jha-advanced-table/jha-advanced-table";
import {
  deleteRequest,
  fixedEncodeURIComponent,
  getRequest,
  putRequest,
} from "../../utils/jha-fetch";
import { Apis } from "../../utils/api-constants";
import { getErrorMessage } from "../../utils/getErrorMessage";
import { GlobalVariables } from "../../utils/constants";
import { UserTypes } from "../../utils/constants";
import {
  ADVANCED_TABLE_SORT_BUTTON_HEADER_STYLES_TEXT,
  applyAdvancedTableHeaderLayout,
  decryptValue,
  showToastMessage,
  buildAdvancedTableJhaTooltipOverflowEscapeCss,
  buildAdvancedTableEllipsisColumnShadowCss,
  renderAdvancedTableEllipsisCell,
  stripAdvancedTableRedundantTitles,
} from "../../utils/app-utils";
import {
  dateTimeColumnLabel,
  EFM_TIMEZONE_GRID_TABLE_SHADOW_STYLES_TEXT,
  EFM_TIMEZONE_GRID_TABLE_STYLE,
  formatEpochSecondsForDisplay,
  normalizeEpochSeconds,
  renderGridWithTimezoneBanner,
} from "../../utils/datetime-display";
import { AppRouters } from "../../utils/app-router";
import { isSessionBusinessUnitAllowed } from "../../utils/business-unit-session";
import {
  InstitutionType,
  InstitutionListResponse,
  normalizeInstitution,
} from "../../types/BusinessUnits/InstitutionType";
import Cookies from "js-cookie";
import "../../Components/Loader";
import {
  jhaDropdownMenuPanelStyles,
  jhaDropdownMenuPanelStylesText,
} from "../../styles/jha-dropdown-menu-panel";
import { openJhftDialog } from "../../Components/JhftJhaDialog";
import { StatusConstants } from "../../utils/apiStatusConstants";
import {
  INSTITUTIONS_LIST_REFRESH_EVENT,
  InstitutionsListRefreshDetail,
  requestInstitutionsListRefresh,
} from "../../utils/institution-list-refresh";
import {
  INSTITUTION_CONCURRENCY_USER_MESSAGE,
  isInstitutionConcurrencyError,
} from "../../utils/institution-concurrency";
import { FeatureFlags } from "../../utils/launchdarkly-config";
import { launchDarkly } from "../../utils/launchdarkly-service";
import { isInitialInstitutionFeatureEnabled } from "../../utils/initial-institution-feature-gate";

const INSTITUTIONS_ELLIPSIS_TITLE_COLUMN_IDS = new Set([
  "institutionRtId",
  "consumerNameProduct",
]);

@customElement("institutions-main-view")
export class InstitutionsMainView extends routingMixin(LitElement) {
  static get is() {
    return "institutions-main-view";
  }

  @property({ reflect: true, attribute: "business-unit-id" })
  businessUnitId = "";

  @property({ type: Boolean }) apiLoading = false;
  @property({ type: String })
  loggedUserType = decryptValue(Cookies.get("userType") as string);
  @property({ type: Boolean }) isReadOnlyUser = /readonly/i.test(
    decryptValue(Cookies.get("userRole") || "")
  );
  @property({ type: Boolean }) isEnterpriseAdmin = /enterpriseadmin/i.test(
    decryptValue(Cookies.get("userType") || "")
  );
  @property({ type: Number }) allRecords = 100000;

  @state() private deleteInProgress = false;
  @state() private setDefaultInProgress = false;
  private setDefaultDialogActive = false;
  private institutionsLoadSeq = 0;

  private static readonly INSTITUTION_ALREADY_DEFAULT_MESSAGE =
    "This institution is already the default.";

  private static readonly SET_DEFAULT_GENERIC_MESSAGE =
    "Setting this institution as default will replace the current default institution for this business unit. Do you want to continue?";

  get institutionColumns() {
    const baseColumns = [
      {
        id: "institutionRtId",
        label: "RT ID",
        sortBy: true,
        valueRenderer: (val: string) => renderAdvancedTableEllipsisCell(val),
      },
      {
        id: "institutionEnvironment",
        label: "ENVIRONMENT",
        sortBy: true,
      },
      {
        id: "isDefault",
        label: "DEFAULT",
        sortBy: true,
        valueRenderer: (val: boolean) =>
          val
            ? html`<span class="default-badge" data-auto-id="defaultBadge"
                >Default</span
              >`
            : html``,
      },
      {
        id: "consumerNameProduct",
        label: "CONSUMER NAME / PRODUCT",
        sortBy: true,
        valueRenderer: (val: string) => renderAdvancedTableEllipsisCell(val),
      },
      {
        id: "updateDateTime",
        label: dateTimeColumnLabel("UPDATED ON"),
        sortBy: true,
        dataType: "number",
        valueFormatter: () => "",
        valueRenderer: (val: unknown) =>
          html`<span style="white-space: nowrap;">${formatEpochSecondsForDisplay(normalizeEpochSeconds(val))}</span>`,
      },
    ];

    const actionColumn = this.showInstitutionManagementActions
      ? {
        id: "actionId",
        label: "",
        alignRight: true,
        valueFormatter: () => "",
        valueRenderer: (_val: unknown, row: InstitutionType) =>
          html`
              <jha-dropdown data-auto-id="institutionEditDropdown">
                <jha-dropdown-toggle
                  slot="toggle"
                  tabindex="0"
                  aria-expanded="false"
                  aria-haspopup="true"
                  role="button"
                >
                  <jha-icon-view-more class="icon"></jha-icon-view-more>
                </jha-dropdown-toggle>
                <jha-dropdown-menu>
                  <jha-dropdown-menu-item
                    data-auto-id="institutionViewMenuItem"
                    role="link"
                    @click=${() =>
              this.onViewInstitutionDetail(row.institutionUuid)}
                  >
                    <a>View details</a>
                  </jha-dropdown-menu-item>
                  <jha-dropdown-menu-item
                    data-auto-id="institutionEditMenuItem"
                    role="link"
                    @click=${() => this.onEditInstitution(row.institutionUuid)}
                  >
                    <a>Edit</a>
                  </jha-dropdown-menu-item>
                  ${!row.isDefault
              ? html`
                        <jha-dropdown-menu-item
                          data-auto-id="institutionSetDefaultMenuItem"
                          role="link"
                          @click=${() =>
                  this.onSetDefaultInstitution(row.institutionUuid)}
                        >
                          <a>Set as default</a>
                        </jha-dropdown-menu-item>
                        <jha-dropdown-menu-item
                          data-auto-id="institutionDeleteMenuItem"
                          role="link"
                          @click=${() =>
                  this.onDeleteInstitution(row.institutionUuid)}
                        >
                          <a>Delete</a>
                        </jha-dropdown-menu-item>
                      `
              : html``}
                </jha-dropdown-menu>
              </jha-dropdown>
            `,
      }
      : {
        id: "actionId",
        label: "",
        alignRight: true,
        valueFormatter: () => "",
        valueRenderer: (_val: unknown, row: InstitutionType) =>
          html`
              <jha-tooltip left text="View details">
                <jha-icon-view-more
                  class="icon"
                  data-auto-id=${"openInstitutionDetail_" + row.institutionUuid}
                  style="cursor: pointer;"
                  @click=${() =>
              this.onViewInstitutionDetail(row.institutionUuid)}
                >
                </jha-icon-view-more>
              </jha-tooltip>
            `,
      };

    return [...baseColumns, actionColumn];
  }

  @property({ type: Object })
  advancedTableConfig = {
    apiControlled: false,
    apiTotal: 100,
    sort: {
      columnId: "updateDateTime",
      descending: true,
    },
  };

  @property({ type: Number }) pageLimit = 20;
  @property({ type: Array }) institutionsData: InstitutionType[] = [];
  @property({ type: String }) filterEnvironment = "";
  @property({ type: String }) filterDefault = "";
  @property({ type: Boolean }) hasLoadedOnce = false;
  @property({ type: String }) businessUnitName = "";
  private environmentOptions: string[] = [];
  private _handleInstitutionsListRefresh = (
    event: CustomEvent<InstitutionsListRefreshDetail>
  ) => {
    if (event.detail?.businessUnitId === this.businessUnitId) {
      this.clearNonDefaultListFilter();
      this.loadInstitutions();
    }
  };

  static readonly styles = [jhaDropdownMenuPanelStyles, css`
    .icon {
      cursor: pointer;
      color: var(--jha-color-primary);
      width: 20px;
      height: 20px;
    }
    .default-badge {
      display: inline-block;
      padding: 2px 10px;
      border-radius: 12px;
      font-size: 12px;
      font-weight: 600;
      background-color: var(--jha-color-success-light, #d4edda);
      color: var(--jha-color-success, #155724);
    }
    #institutionsMain {
      display: flex;
      flex-direction: column;
      padding: 24px;
      flex: 1;
      overflow: hidden;
    }
    #formCon {
      display: flex;
      flex-direction: row;
      gap: 15px;
      align-items: center;
      justify-content: space-between;
    }
    .titleRow {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 16px;
    }
    .filterContainer {
      display: flex;
      align-items: center;
      gap: 16px;
    }
    jha-form-select {
      min-width: 200px;
    }
    jha-card {
      margin-top: 10px;
      flex: 1;
      overflow: hidden;
      margin-left: 0px;
      margin-right: 0px;
      padding: 5px;
    }
    #breadcrumb {
      font-size: 14px;
      color: var(--jha-color-secondary-text);
      margin-bottom: 8px;
    }
    #breadcrumb a {
      color: var(--jha-color-primary);
      text-decoration: none;
      cursor: pointer;
    }
    #breadcrumb a:hover {
      text-decoration: underline;
    }
    #noData {
      display: flex;
      justify-content: center;
      padding: 40px;
      font-size: 16px;
      color: var(--jha-color-secondary-text);
    }
    #table-container {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
    }
  `];

  private static toEpochSecondsForSort(raw: unknown): unknown {
    if (raw == null || raw === "") return raw;
    if (typeof raw === "number" && Number.isFinite(raw))
      return raw < 10000000000 ? raw : Math.floor(raw / 1000);
    const s = String(raw).trim();
    if (/^\d{10,13}$/.test(s)) {
      const n = parseInt(s, 10);
      return n < 10000000000 ? n : Math.floor(n / 1000);
    }
    const ms = Date.parse(s);
    if (!Number.isNaN(ms)) return Math.floor(ms / 1000);
    return raw;
  }

  get filteredInstitutions() {
    return this.institutionsData.map((item) => ({
      ...item,
      updateDateTime: InstitutionsMainView.toEpochSecondsForSort(
        item.updateDateTime
      ),
      createDateTime: InstitutionsMainView.toEpochSecondsForSort(
        item.createDateTime
      ),
      actionId: item.institutionUuid ?? "",
    }));
  }

  get isFiltered(): boolean {
    return this.filterEnvironment !== "" || this.filterDefault !== "";
  }

  get canManageInstitutions(): boolean {
    if (this.isReadOnlyUser) {
      return false;
    }
    if (this.isEnterpriseAdmin) {
      return true;
    }
    return this.loggedUserType?.toLowerCase() === UserTypes.businessadmin;
  }

  get showInstitutionManagementActions(): boolean {
    return this.canManageInstitutions && isInitialInstitutionFeatureEnabled();
  }

  private handleInitialInstitutionFlagChange = (): void => {
    this.requestUpdate();
  };

  private refreshFlagValues = (): void => {
    this.requestUpdate();
  };

  get noContentMessage(): string {
    if (this.isFiltered) {
      return "No institutions match the current filters. Clear filters to see all institutions.";
    }
    return "No institutions found for this business unit.";
  }

  private institutionsUrlWithFilters(basePath: string): string {
    const params: string[] = [];
    if (this.filterEnvironment) {
      params.push(`environment=${encodeURIComponent(this.filterEnvironment)}`);
    }
    if (this.filterDefault) {
      params.push(`defaultStatus=${encodeURIComponent(this.filterDefault)}`);
    }
    if (params.length) {
      return `${basePath}?${params.join("&")}`;
    }
    return basePath;
  }

  onViewInstitutionDetail(institutionUuid: string) {
    if (!institutionUuid || !this.businessUnitId) return;
    const basePath = `/business-units/${fixedEncodeURIComponent(
      this.businessUnitId
    )}/institutions/detail/${fixedEncodeURIComponent(institutionUuid)}`;
    AppRouters.go(this.institutionsUrlWithFilters(basePath));
  }

  onEditInstitution(institutionUuid: string) {
    if (!institutionUuid || !this.businessUnitId) return;
    if (!isInitialInstitutionFeatureEnabled()) {
      showToastMessage(
        "Institution management is not available.",
        "danger"
      );
      return;
    }
    if (!this.canManageInstitutions) {
      showToastMessage(
        "You do not have permission to edit institutions.",
        "danger"
      );
      return;
    }
    const basePath = `/business-units/${fixedEncodeURIComponent(
      this.businessUnitId
    )}/institutions/edit-institution/${fixedEncodeURIComponent(institutionUuid)}`;
    AppRouters.go(this.institutionsUrlWithFilters(basePath));
  }

  private clearNonDefaultListFilter() {
    if (this.filterDefault === "false") {
      this.filterDefault = "";
      this.syncFilterUrl();
    }
  }

  private async findCurrentDefaultInstitution(
    targetUuid: string
  ): Promise<InstitutionType | undefined> {
    try {
      const listUrl =
        Apis.INSTITUTION_ALL +
        `?businessUnitId=${fixedEncodeURIComponent(this.businessUnitId)}` +
        `&count=${this.allRecords}`;
      const response = await getRequest<InstitutionListResponse>(listUrl);
      if (!response || response instanceof Response) {
        return undefined;
      }
      if (response.messageStatus !== null) {
        return undefined;
      }
      const institutions = (response.institutions || []).map(
        (row: Record<string, unknown>) => normalizeInstitution(row)
      );
      return institutions.find(
        (i) => i.isDefault && i.institutionUuid !== targetUuid
      );
    } catch {
      return undefined;
    }
  }

  private buildSetDefaultConfirmMessage(
    currentDefault: InstitutionType | undefined,
    targetUuid: string
  ): string {
    if (
      currentDefault?.institutionUuid &&
      currentDefault.institutionUuid !== targetUuid &&
      currentDefault.isDefault
    ) {
      return `Setting this institution as default will replace the current default institution (RT ID: ${currentDefault.institutionRtId}, Environment: ${currentDefault.institutionEnvironment}). Do you want to continue?`;
    }
    return InstitutionsMainView.SET_DEFAULT_GENERIC_MESSAGE;
  }

  async onSetDefaultInstitution(institutionUuid: string) {
    if (
      !institutionUuid ||
      !this.businessUnitId ||
      this.apiLoading ||
      this.deleteInProgress ||
      this.setDefaultInProgress ||
      this.setDefaultDialogActive
    ) {
      return;
    }
    if (!this.canManageInstitutions) {
      showToastMessage(
        "You do not have permission to update institutions.",
        "danger"
      );
      return;
    }
    if (!isInitialInstitutionFeatureEnabled()) {
      showToastMessage(
        "Institution management is not available.",
        "danger"
      );
      return;
    }

    this.setDefaultDialogActive = true;
    try {
      let currentDefault = this.institutionsData.find(
        (i) => i.isDefault && i.institutionUuid !== institutionUuid
      );
      if (!currentDefault) {
        currentDefault = await this.findCurrentDefaultInstitution(
          institutionUuid
        );
      }
      const confirmMessage = this.buildSetDefaultConfirmMessage(
        currentDefault,
        institutionUuid
      );

      const result = await openJhftDialog({
        variant: "info",
        title: "Set as default institution",
        message: confirmMessage,
        cancelLabel: "Cancel",
        confirmLabel: "Set as default",
      });
      if (result !== "confirm") {
        return;
      }
    } finally {
      this.setDefaultDialogActive = false;
    }

    this.setDefaultInProgress = true;
    try {
      const getUrl =
        Apis.INSTITUTION_GET +
        `/${fixedEncodeURIComponent(institutionUuid)}` +
        `?businessUnitId=${fixedEncodeURIComponent(this.businessUnitId)}`;
      const institutionData = await getRequest(getUrl);

      if (!institutionData) {
        return;
      }

      if (institutionData instanceof Response) {
        if (institutionData.status === StatusConstants.NOT_FOUND_USER_CODE) {
          showToastMessage("Institution not found.", "danger");
        } else if (
          institutionData.status === StatusConstants.UNAUTHORIZED_USER_CODE
        ) {
          showToastMessage(
            "You do not have permission to update this institution.",
            "danger"
          );
        } else {
          showToastMessage("Something went wrong, please try again.", "danger");
        }
        return;
      }

      if (institutionData.messageStatus != null) {
        const errMsg = getErrorMessage(institutionData.details);
        showToastMessage(
          errMsg.trim() || "Something went wrong, please try again.",
          "danger"
        );
        return;
      }

      const inst = normalizeInstitution(institutionData);
      if (
        !inst.institutionUuid ||
        !inst.businessUnitId ||
        inst.businessUnitId !== this.businessUnitId
      ) {
        showToastMessage("Institution not found.", "danger");
        return;
      }

      if (inst.isDefault) {
        showToastMessage(
          InstitutionsMainView.INSTITUTION_ALREADY_DEFAULT_MESSAGE,
          "success"
        );
        this.clearNonDefaultListFilter();
        await this.loadInstitutions();
        return;
      }

      const eTag = inst.eTag ?? "";
      if (!eTag) {
        showToastMessage(
          "Institution version is missing. Reload and try again.",
          "danger"
        );
        return;
      }

      const updateUrl =
        Apis.INSTITUTION_UPDATE +
        `/${fixedEncodeURIComponent(institutionUuid)}` +
        `?businessUnitId=${fixedEncodeURIComponent(this.businessUnitId)}`;
      const putBody = {
        institutionRtId: inst.institutionRtId,
        institutionEnvironment: inst.institutionEnvironment,
        consumerNameProduct: inst.consumerNameProduct,
        isDefault: true,
        updatedBy: decryptValue(Cookies.get("userId") || ""),
      };
      const response = await putRequest(updateUrl, eTag, putBody);

      if (!response) {
        return;
      }

      const httpStatus =
        response instanceof Response ? response.status : response?.status;
      if (httpStatus === StatusConstants.UNAUTHORIZED_USER_CODE) {
        showToastMessage(
          "You do not have permission to update this institution.",
          "danger"
        );
        return;
      }
      if (httpStatus === StatusConstants.NOT_FOUND_USER_CODE) {
        showToastMessage("Institution not found.", "danger");
        return;
      }
      if (httpStatus === 412) {
        showToastMessage(INSTITUTION_CONCURRENCY_USER_MESSAGE, "danger");
        return;
      }
      if (response instanceof Response) {
        showToastMessage("Something went wrong, please try again.", "danger");
        return;
      }

      if (response?.messageStatus === null) {
        showToastMessage("Default institution updated successfully.", "success");
        this.clearNonDefaultListFilter();
        await this.loadInstitutions();
        requestInstitutionsListRefresh(this.businessUnitId);
        return;
      }

      if (response?.details?.length > 0) {
        if (isInstitutionConcurrencyError(response.details)) {
          showToastMessage(INSTITUTION_CONCURRENCY_USER_MESSAGE, "danger");
        } else {
          showToastMessage(getErrorMessage(response.details), "danger");
        }
        return;
      }

      const errMsg = getErrorMessage(response?.details);
      showToastMessage(
        errMsg.trim() || "Something went wrong, please try again.",
        "danger"
      );
    } catch {
      showToastMessage("Something went wrong, please try again.", "danger");
    } finally {
      this.setDefaultInProgress = false;
    }
  }

  async onDeleteInstitution(institutionUuid: string) {
    if (
      !institutionUuid ||
      !this.businessUnitId ||
      this.apiLoading ||
      this.deleteInProgress ||
      this.setDefaultInProgress ||
      this.setDefaultDialogActive
    ) {
      return;
    }
    if (!this.canManageInstitutions) {
      showToastMessage(
        "You do not have permission to delete institutions.",
        "danger"
      );
      return;
    }
    if (!isInitialInstitutionFeatureEnabled()) {
      showToastMessage(
        "Institution management is not available.",
        "danger"
      );
      return;
    }

    this.deleteInProgress = true;
    try {
      const result = await openJhftDialog({
        variant: "danger",
        title: "Delete Institution",
        message:
          "Are you sure you want to delete this institution? This action cannot be undone.",
        cancelLabel: "Cancel",
        confirmLabel: "Delete",
      });
      if (result !== "confirm") {
        return;
      }

      const getUrl =
        Apis.INSTITUTION_GET +
        `/${fixedEncodeURIComponent(institutionUuid)}` +
        `?businessUnitId=${fixedEncodeURIComponent(this.businessUnitId)}`;
      const institutionData = await getRequest(getUrl);

      if (!institutionData) {
        return;
      }

      if (institutionData instanceof Response) {
        if (institutionData.status === StatusConstants.NOT_FOUND_USER_CODE) {
          showToastMessage("Institution not found.", "danger");
        } else if (
          institutionData.status === StatusConstants.UNAUTHORIZED_USER_CODE
        ) {
          showToastMessage(
            "You do not have permission to delete this institution.",
            "danger"
          );
        } else {
          showToastMessage("Something went wrong, please try again.", "danger");
        }
        return;
      }

      if (institutionData.messageStatus != null) {
        const errMsg = getErrorMessage(institutionData.details);
        showToastMessage(
          errMsg.trim() || "Something went wrong, please try again.",
          "danger"
        );
        return;
      }

      const inst = normalizeInstitution(institutionData);
      if (
        !inst.institutionUuid ||
        !inst.businessUnitId ||
        inst.businessUnitId !== this.businessUnitId
      ) {
        showToastMessage("Institution not found.", "danger");
        return;
      }

      const eTag = inst.eTag ?? "";
      if (!eTag) {
        showToastMessage(
          "Institution version is missing. Reload and try again.",
          "danger"
        );
        return;
      }

      const deleteUrl =
        Apis.INSTITUTION_DELETE +
        `/${fixedEncodeURIComponent(institutionUuid)}` +
        `?businessUnitId=${fixedEncodeURIComponent(this.businessUnitId)}`;
      const deleteResponse = await deleteRequest(deleteUrl, eTag);

      if (
        deleteResponse?.status === StatusConstants.DELETE_INSTITUTION_SUCCESS_CODE
      ) {
        showToastMessage("Institution deleted successfully.", "success");
        this.institutionsData = this.institutionsData.filter(
          (x) => x.institutionUuid !== institutionUuid
        );
        this.advancedTableConfig = {
          ...this.advancedTableConfig,
          apiTotal: Math.max(0, (this.advancedTableConfig.apiTotal ?? 0) - 1),
        };
        requestInstitutionsListRefresh(this.businessUnitId);
      } else if (deleteResponse && !deleteResponse.ok) {
        if (deleteResponse.status === 412) {
          showToastMessage(INSTITUTION_CONCURRENCY_USER_MESSAGE, "danger");
          return;
        }
        if (deleteResponse.status === StatusConstants.NOT_FOUND_USER_CODE) {
          showToastMessage("Institution not found.", "danger");
          return;
        }
        if (deleteResponse.status === StatusConstants.UNAUTHORIZED_USER_CODE) {
          showToastMessage(
            "You do not have permission to delete this institution.",
            "danger"
          );
          return;
        }
        try {
          const errorData = await deleteResponse.json();
          if (errorData?.details?.length > 0) {
            if (isInstitutionConcurrencyError(errorData.details)) {
              showToastMessage(INSTITUTION_CONCURRENCY_USER_MESSAGE, "danger");
            } else {
              showToastMessage(getErrorMessage(errorData.details), "danger");
            }
          } else {
            showToastMessage("Something went wrong, please try again.", "danger");
          }
        } catch {
          showToastMessage("Something went wrong, please try again.", "danger");
        }
      } else if (!deleteResponse) {
        return;
      } else {
        showToastMessage("Something went wrong, please try again.", "danger");
      }
    } catch {
      showToastMessage("Something went wrong, please try again.", "danger");
    } finally {
      this.deleteInProgress = false;
    }
  }

  onBackToBusinessUnits() {
    AppRouters.go("/business-units");
  }

  onAddInstitution() {
    if (!this.businessUnitId) {
      return;
    }
    if (!isInitialInstitutionFeatureEnabled()) {
      showToastMessage(
        "Institution management is not available.",
        "danger"
      );
      return;
    }
    if (!this.canManageInstitutions) {
      showToastMessage(
        "You do not have permission to create institutions.",
        "danger"
      );
      return;
    }
    let url = `/business-units/${fixedEncodeURIComponent(
      this.businessUnitId
    )}/institutions/add-institution`;
    const params: string[] = [];
    if (this.filterEnvironment) {
      params.push(
        `environment=${encodeURIComponent(this.filterEnvironment)}`
      );
    }
    if (this.filterDefault) {
      params.push(`defaultStatus=${encodeURIComponent(this.filterDefault)}`);
    }
    if (params.length) {
      url += `?${params.join("&")}`;
    }
    AppRouters.go(url);
  }

  onFilterEnvironmentChange(e: Event) {
    const select = e.target as HTMLSelectElement;
    this.filterEnvironment = select.value;
    this.syncFilterUrl();
    this.loadInstitutions();
  }

  onFilterDefaultChange(e: Event) {
    const select = e.target as HTMLSelectElement;
    this.filterDefault = select.value;
    this.syncFilterUrl();
    this.loadInstitutions();
  }

  onClearFilters() {
    this.filterEnvironment = "";
    this.filterDefault = "";
    this.syncFilterUrl();
    this.loadInstitutions();
  }

  private syncFilterUrl() {
    let url = `/business-units/${fixedEncodeURIComponent(
      this.businessUnitId
    )}/institutions`;
    const params: string[] = [];
    if (this.filterEnvironment) {
      params.push(
        `environment=${encodeURIComponent(this.filterEnvironment)}`
      );
    }
    if (this.filterDefault) {
      params.push(`defaultStatus=${encodeURIComponent(this.filterDefault)}`);
    }
    if (params.length) url += `?${params.join("&")}`;
    window.history.replaceState(null, "", url);
  }

  private resetListStateForRoute() {
    this.institutionsData = [];
    this.environmentOptions = [];
    this.hasLoadedOnce = false;
  }

  private mergeEnvironmentOptions(normalized: InstitutionType[]) {
    const envs = new Set(this.environmentOptions);
    for (const inst of normalized) {
      if (inst.institutionEnvironment) envs.add(inst.institutionEnvironment);
    }
    if (this.filterEnvironment) envs.add(this.filterEnvironment);
    this.environmentOptions = [...envs].filter(Boolean).sort();
  }

  async loadInstitutions() {
    if (!this.businessUnitId) {
      showToastMessage("Missing business unit identifier.", "danger");
      return;
    }
    this.apiLoading = true;
    const loadSeq = ++this.institutionsLoadSeq;
    try {
      let url =
        Apis.INSTITUTION_ALL +
        `?businessUnitId=${fixedEncodeURIComponent(this.businessUnitId)}` +
        `&count=${this.allRecords}`;

      if (this.filterEnvironment) {
        url += `&environment=${fixedEncodeURIComponent(
          this.filterEnvironment
        )}`;
      }
      if (this.filterDefault === "true" || this.filterDefault === "false") {
        url += `&isDefault=${this.filterDefault}`;
      }

      const response = await getRequest<InstitutionListResponse>(url);

      if (loadSeq !== this.institutionsLoadSeq) {
        return;
      }

      if (!response) {
        showToastMessage(
          "Something went wrong loading institutions, please try again.",
          "danger"
        );
        this.institutionsData = [];
        return;
      }

      if (response instanceof Response) {
        if (response.status === 401) {
          showToastMessage("You do not have permission to view institutions.", "danger");
        } else if (response.status === 404) {
          showToastMessage("Institutions not found for this business unit.", "danger");
        } else {
          showToastMessage("Something went wrong loading institutions, please try again.", "danger");
        }
        this.institutionsData = [];
        return;
      }

      if (response.messageStatus === null) {
        const normalized = (response.institutions || []).map(
          (row: Record<string, unknown>) => normalizeInstitution(row)
        );
        this.institutionsData = normalized;
        this.mergeEnvironmentOptions(normalized);

        this.advancedTableConfig = {
          ...this.advancedTableConfig,
          apiTotal: response.totalCount ?? normalized.length,
          sort: {
            columnId: "updateDateTime",
            descending: true,
          },
        };
        this.hasLoadedOnce = true;
      } else if (response.details?.length > 0) {
        showToastMessage(getErrorMessage(response.details), "danger");
        this.institutionsData = [];
      } else {
        showToastMessage(
          "Something went wrong loading institutions, please try again.",
          "danger"
        );
        this.institutionsData = [];
      }
    } catch {
      showToastMessage(
        "Something went wrong loading institutions, please try again.",
        "danger"
      );
      this.institutionsData = [];
    } finally {
      if (loadSeq === this.institutionsLoadSeq) {
        this.apiLoading = false;
      }
    }
  }

  private async verifyBusinessUnitAccess(): Promise<boolean> {
    try {
      const buData = await getRequest(
        Apis.GET_BUSINESSUNIT +
        `/${fixedEncodeURIComponent(this.businessUnitId)}`
      );

      if (!buData) {
        showToastMessage("Something went wrong, please try again.", "danger");
        AppRouters.go("/business-units");
        return false;
      }

      if (buData instanceof Response) {
        if (buData.status === 401) {
          showToastMessage(
            "You do not have permission to view this Business Unit.",
            "danger"
          );
        } else if (buData.status === 404) {
          showToastMessage(
            "Business Unit not found.",
            "danger"
          );
        } else {
          showToastMessage(
            "Something went wrong, please try again.",
            "danger"
          );
        }
        AppRouters.go("/business-units");
        return false;
      }

      if (
        this.loggedUserType?.toLowerCase() === UserTypes.businessadmin &&
        !isSessionBusinessUnitAllowed(buData)
      ) {
        showToastMessage(
          "You do not have permission to view this Business Unit.",
          "danger"
        );
        AppRouters.go("/business-units");
        return false;
      }

      this.businessUnitName =
        buData.businessUnitName ?? buData.BusinessUnitName ?? "";
      return true;
    } catch {
      showToastMessage(
        "Something went wrong, please try again.",
        "danger"
      );
      AppRouters.go("/business-units");
      return false;
    }
  }

  async connectedCallback() {
    super.connectedCallback();
    this.refreshFlagValues();
    launchDarkly.whenReady().then(() => this.refreshFlagValues());
    launchDarkly.on(FeatureFlags.INITIAL_INSTITUTION, this.handleInitialInstitutionFlagChange);
    window.addEventListener(
      INSTITUTIONS_LIST_REFRESH_EVENT,
      this._handleInstitutionsListRefresh as EventListener
    );
    document.title = GlobalVariables.MAIN_TITLE?.concat(
      " > Institutions"
    );
  }

  disconnectedCallback() {
    launchDarkly.off(FeatureFlags.INITIAL_INSTITUTION, this.handleInitialInstitutionFlagChange);
    window.removeEventListener(
      INSTITUTIONS_LIST_REFRESH_EVENT,
      this._handleInstitutionsListRefresh as EventListener
    );
    super.disconnectedCallback();
  }

  async routeEnter(
    currentNode: unknown,
    nextNodeIfExists: unknown,
    routeId: string,
    context: unknown
  ) {
    await super.routeEnter(currentNode, nextNodeIfExists, routeId, context);
    if (!nextNodeIfExists) {
      this.resetListStateForRoute();
      const params = new URLSearchParams(window.location.search);
      const envParam = params.get("environment") ?? "";
      const defaultParam = params.get("defaultStatus") ?? "";
      this.filterEnvironment = envParam;
      this.filterDefault =
        defaultParam === "true" || defaultParam === "false"
          ? defaultParam
          : "";

      const allowed = await this.verifyBusinessUnitAccess();
      if (allowed) {
        this.advancedTableConfig = {
          ...this.advancedTableConfig,
          sort: {
            columnId: "updateDateTime",
            descending: true,
          },
        };
        await this.loadInstitutions();
      } else {
        this.institutionsData = [];
      }
    }
  }

  updated(changed: PropertyValues) {
    super.updated?.(changed);
    const table = this.renderRoot.querySelector(
      "jha-advanced-table"
    ) as HTMLElement | null;
    if (table) {
      table.toggleAttribute(
        "data-api-loading",
        this.apiLoading
      );
      table.toggleAttribute(
        "data-has-data",
        this.institutionsData.length > 0
      );
    }
    requestAnimationFrame(() => this.injectAdvancedTableStyles());
  }

  private handleTableUpdate() {
    requestAnimationFrame(() => this.injectAdvancedTableStyles());
  }

  private injectAdvancedTableStyles() {
    const table = this.renderRoot.querySelector(
      "jha-advanced-table"
    ) as HTMLElement | null;
    const root = table?.shadowRoot;
    if (!root) return;
    const css = `
            ${ADVANCED_TABLE_SORT_BUTTON_HEADER_STYLES_TEXT}
            ${EFM_TIMEZONE_GRID_TABLE_SHADOW_STYLES_TEXT}
            ${jhaDropdownMenuPanelStylesText}
            .loading jh-progress { visibility: hidden; }
            :host([data-api-loading]) .no-content,
            :host([data-has-data]) .no-content { visibility: hidden; }
            .no-content p {
                font-size: 20px;
                font-weight: 600;
                margin: 0;
            }
            ${buildAdvancedTableEllipsisColumnShadowCss([
      "institutionRtId",
      "consumerNameProduct",
    ])}
            ${buildAdvancedTableJhaTooltipOverflowEscapeCss(["actionId"])}
        `;
    let style = root.querySelector(
      "style[data-acme-institutions-table]"
    ) as HTMLStyleElement | null;
    if (!style) {
      style = document.createElement("style");
      style.setAttribute("data-acme-institutions-table", "");
      root.appendChild(style);
    }
    style.textContent = css;
    applyAdvancedTableHeaderLayout(root);
    stripAdvancedTableRedundantTitles(root, INSTITUTIONS_ELLIPSIS_TITLE_COLUMN_IDS);
  }

  renderFilters() {
    return html`
      <div class="filterContainer">
        <jha-form-select
          data-auto-id="institutionEnvironmentFilter"
          label="Environment"
          outline
          .value=${this.filterEnvironment}
          @change=${this.onFilterEnvironmentChange}
        >
          <option value="">All Environments</option>
          ${this.environmentOptions.map(
      (env) => html`<option value=${env}>${env}</option>`
    )}
        </jha-form-select>

        <jha-form-select
          data-auto-id="institutionDefaultFilter"
          label="Default Status"
          outline
          .value=${this.filterDefault}
          @change=${this.onFilterDefaultChange}
        >
          <option value="">All</option>
          <option value="true">Default Only</option>
          <option value="false">Non-Default Only</option>
        </jha-form-select>

        ${this.isFiltered
        ? html`
              <jha-button
                data-auto-id="clearFiltersButton"
                type="button"
                tertiary
                @click=${this.onClearFilters}
              >
                Clear Filters
              </jha-button>
            `
        : html``}
      </div>
    `;
  }

  renderTable() {
    return html`
      <jha-advanced-table
        style=${EFM_TIMEZONE_GRID_TABLE_STYLE}
        data-auto-id="institutionsTable"
        .tableConfig=${this.advancedTableConfig}
        .columns=${this.institutionColumns}
        .data=${this.filteredInstitutions}
        .fullWidthColumns=${true}
        .pageLimit=${this.pageLimit}
        .allowPageChange=${true}
        .allowPageLimitChange=${true}
        .loading=${this.apiLoading || this.deleteInProgress || this.setDefaultInProgress}
        .noContentMessage=${this.noContentMessage}
        @table-update=${this.handleTableUpdate}
      ></jha-advanced-table>
    `;
  }

  render() {
    return html`
      <slot>
        ${this.apiLoading ? html`<circle-loader></circle-loader>` : undefined}
        <div id="table-container">
          <div id="institutionsMain">
            <div id="breadcrumb">
              <a @click=${this.onBackToBusinessUnits}>Business Units</a>
              &rsaquo;
              ${this.businessUnitName || this.businessUnitId}
              &rsaquo; Institutions
            </div>
            <div id="formCon">
              <div class="titleRow">
                <h1>Institutions</h1>
                ${!this.canManageInstitutions
        ? html`
                      <jha-button
                        data-auto-id="createInstitutionNavButton"
                        type="button"
                        primary
                        large
                        disabled
                      >
                        <jha-icon-plus slot="icon-left"></jha-icon-plus>
                        Create Institution
                      </jha-button>
                    `
        : this.showInstitutionManagementActions
          ? html`
                        <jha-tooltip left text="Create a new institution.">
                          <jha-button
                            data-auto-id="createInstitutionNavButton"
                            type="button"
                            primary
                            large
                            @click=${this.onAddInstitution}
                          >
                            <jha-icon-plus slot="icon-left"></jha-icon-plus>
                            Create Institution
                          </jha-button>
                        </jha-tooltip>
                      `
          : html``}
              </div>
              ${this.renderFilters()}
            </div>
            <jha-card
              >${renderGridWithTimezoneBanner(this.renderTable())}</jha-card
            >
          </div>
        </div>
      </slot>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "institutions-main-view": InstitutionsMainView;
  }
}
